<template>
  <v-card class="card--shadow">
    <v-card-title class="purple accent-4 white--text pa-2">
      <h2 class="card--title">{{ timesTitle }}</h2>
      <v-spacer />
      <v-btn
        :to="'/edit-presumptive-times/' + diagonsis.id"
        fab
        dark
        small
        color="orange lighten-1"
        class="mr-2 white--text"
        depressed
      >
        <v-icon>mdi-pencil-outline</v-icon>
      </v-btn>
      <v-btn
        @click="openConfrimBox(diagonsis.id)"
        fab
        dark
        small
        color="red lighten-1"
        class="white--text"
        depressed
      >
        <v-icon> mdi-delete-outline </v-icon>
      </v-btn>
      <confirm-box
        :dialog="dialog"
        @confirmed="deletPresumptive"
        @cancel="cancel"
      />
    </v-card-title>

    <v-card-text class="patient-detail px-8">
      <v-row>
        <v-col lg="4">
          <v-row>
            <v-col class="header" lg="6">
              <h3>Register Date</h3>
            </v-col>
            <v-col lg="6">
              <p>{{ diagonsis.register_date }}</p>
            </v-col>
          </v-row>
        </v-col>
        <v-col lg="4">
          <v-row>
            <v-col class="header" lg="6">
              <h3>Refer from</h3>
            </v-col>
            <v-col lg="6">
              <p>{{ diagonsis.refer_from_name.name }}</p>
            </v-col>
          </v-row>
        </v-col>
        <v-col lg="4">
          <v-row>
            <v-col class="header" lg="6">
              <h3>Refer Type</h3>
            </v-col>
            <v-col lg="6">
              <p>{{ diagonsis.refer_type_name.name }}</p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row>
        <v-col lg="8">
          <v-row>
            <v-col class="header" lg="3">
              <h3>Symptons</h3>
            </v-col>
            <v-col lg="9">
              <v-chip
                v-for="(sympton, i) in diagonsis.symptons"
                :key="i"
                class="mr-1"
                color="pink lighten-2 white--text"
              >
                {{ sympton.name }}
              </v-chip>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row>
        <v-col lg="8">
          <v-row>
            <v-col class="header" lg="3">
              <h3>Risk Factor</h3>
            </v-col>
            <v-col lg="9">
              <v-chip
                v-for="(risk_factor, i) in diagonsis.risk_factors"
                :key="i"
                class="mr-1"
                color="pink lighten-2 white--text"
              >
                {{ risk_factor.name }}
              </v-chip>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row>
        <v-col lg="4">
          <v-row>
            <v-col class="header" lg="6">
              <h3>HIV Date</h3>
            </v-col>
            <v-col lg="6">
              <p>{{ getHivStatus() }}</p>
            </v-col>
          </v-row>
        </v-col>
        <v-col lg="4">
          <v-row>
            <v-col class="header-result" lg="6">
              <h3>HIV Result</h3>
            </v-col>
            <v-col lg="6">
              <p v-if="diagonsis.hiv_result_name">
                {{ diagonsis.hiv_result_name.name }}
              </p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row>
        <v-col lg="4">
          <v-row>
            <v-col class="header" lg="6">
              <h3>Sputum Date</h3>
            </v-col>
            <v-col lg="6">
              <p>{{ getSputum() }}</p>
            </v-col>
          </v-row>
        </v-col>
        <v-col lg="4">
          <v-row>
            <v-col class="header-result" lg="6">
              <h3>Sputum Result</h3>
            </v-col>
            <v-col lg="6">
              <p v-if="diagonsis.sputum_result_name">
                {{ diagonsis.sputum_result_name.name }}
              </p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row>
        <v-col lg="4">
          <v-row>
            <v-col class="header" lg="6">
              <h3>CXR Date</h3>
            </v-col>
            <v-col lg="6">
              <p>{{ getCxr() }}</p>
            </v-col>
          </v-row>
        </v-col>
        <v-col lg="4">
          <v-row>
            <v-col class="header-result" lg="6">
              <h3>CXR Result</h3>
            </v-col>
            <v-col lg="6">
              <p v-if="diagonsis.cxr_result_name">
                {{ diagonsis.cxr_result_name.name }}
              </p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row>
        <v-col lg="4">
          <v-row>
            <v-col class="header" lg="6">
              <h3>GeneXpert Date</h3>
            </v-col>
            <v-col lg="6">
              <p>{{ getGeneXpert() }}</p>
            </v-col>
          </v-row>
        </v-col>
        <v-col lg="4">
          <v-row>
            <v-col class="header-result" lg="6">
              <h3>GeneXpert Result</h3>
            </v-col>
            <v-col lg="6">
              <p v-if="diagonsis.gene_xpert_result_name">
                {{ diagonsis.gene_xpert_result_name.name }}
              </p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row>
        <v-col lg="4">
          <v-row>
            <v-col class="header" lg="6">
              <h3>Culture Date</h3>
            </v-col>
            <v-col lg="6">
              <p>{{ getCulture() }}</p>
            </v-col>
          </v-row>
        </v-col>
        <v-col lg="4">
          <v-row>
            <v-col class="header-result" lg="6">
              <h3>Culture Result</h3>
            </v-col>
            <v-col lg="6">
              <p v-if="diagonsis.culture_result_name">
                {{ diagonsis.culture_result_name.name }}
              </p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row>
        <v-col lg="4">
          <v-row>
            <v-col class="header" lg="6">
              <h3>DST Date</h3>
            </v-col>
            <v-col lg="6">
              <p>{{ getDst() }}</p>
            </v-col>
          </v-row>
        </v-col>
        <v-col lg="4">
          <v-row>
            <v-col class="header-result" lg="6">
              <h3>DST Result</h3>
            </v-col>
            <v-col lg="6">
              <p v-if="diagonsis.dst_result_name">
                {{ diagonsis.dst_result_name.name }}
              </p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row>
        <v-col lg="4">
          <v-row>
            <v-col class="header" lg="6">
              <h3>Other Investigation</h3>
            </v-col>
            <v-col lg="6">
              <p>{{ getOtherInv() }}</p>
            </v-col>
          </v-row>
        </v-col>
        <v-col lg="4">
          <v-row>
            <v-col class="header-test" lg="6">
              <h3>Other Investigation Test</h3>
            </v-col>
            <v-col lg="6">
              <p>{{ diagonsis.other_investigation_test }}</p>
            </v-col>
          </v-row>
        </v-col>
        <v-col lg="4">
          <v-row>
            <v-col class="header-result" lg="6">
              <h3>Other Investigation Result</h3>
            </v-col>
            <v-col lg="6">
              <p>{{ diagonsis.other_investigation_result }}</p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row>
        <v-col lg="4">
          <v-row>
            <v-col class="header" lg="6">
              <h3>Conclusion / Treatment</h3>
            </v-col>
            <v-col lg="6">
              <p v-if="diagonsis.conclusion_name">
                {{ diagonsis.conclusion_name.name }}
                ({{ diagonsis.conclusion_code }})
              </p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row>
        <v-col lg="4">
          <v-row>
            <v-col class="header" lg="6">
              <h3>Other Comment</h3>
            </v-col>
            <v-col lg="6">
              <p>{{ diagonsis.other_comment }}</p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import ConfirmBox from "@/components/notification/ConfirmBox";

export default {
  components: {
    ConfirmBox,
  },
  data: () => ({
    item: null,
    dialog: false,
  }),
  props: {
    diagonsis: {
      type: Object,
    },
  },
  computed: {
    timesTitle() {
      let timesTitle = null;
      switch (this.diagonsis.times) {
        case 1:
          timesTitle = "First Time";
          break;
        case 2:
          timesTitle = "Second Time";
          break;
        case 3:
          timesTitle = "Third Time";
          break;
        case 4:
          timesTitle = "Fourth Time";
          break;
        case 5:
          timesTitle = "Fifth Time";
          break;
      }
      return timesTitle;
    },
  },
  methods: {
    openConfrimBox(item) {
      this.item = item;
      this.dialog = !this.dialog;
    },
    deletPresumptive() {
      let data = {
        id: this.item,
      };
      this.$store
        .dispatch("Presumptive/deleteTime", data)
        .then(() => (
            this.$router.go()
          ));
    },
    cancel() {
      this.dialog = !this.dialog;
    },
    getHivStatus() {
      if (this.diagonsis.hiv_status == 2) return "Missing";
      else if (this.diagonsis.hiv_status == 1) return "Not Done";
      else return this.diagonsis.hiv_date;
    },
    getSputum() {
      if (this.diagonsis.sputum_status == 2) return "Missing";
      else if (this.diagonsis.sputum_status == 1) return "Not Done";
      else return this.diagonsis.sputum_date;
    },
    getCxr() {
      if (this.diagonsis.cxr_status == 2) return "Missing";
      else if (this.diagonsis.cxr_status == 1) return "Not Done";
      else return this.diagonsis.cxr_date;
    },
    getGeneXpert() {
      if (this.diagonsis.gene_xpert_status == 2) return "Missing";
      else if (this.diagonsis.gene_xpert_status == 1) return "Not Done";
      else return this.diagonsis.gene_xpert_date;
    },
    getCulture() {
      if (this.diagonsis.culture_status == 2) return "Missing";
      else if (this.diagonsis.culture_status == 1) return "Not Done";
      else return this.diagonsis.culture_date;
    },
    getDst() {
      if (this.diagonsis.dst_status == 2) return "Missing";
      else if (this.diagonsis.dst_status == 1) return "Not Done";
      else return this.diagonsis.dst_date;
    },
    getOtherInv() {
      if (this.diagonsis.other_investigation_status == 2) return "Missing";
      else if (this.diagonsis.other_investigation_status == 1)
        return "Not Done";
      else return this.diagonsis.dst_date;
    },
  },
};
</script>

<style scoped>
h3,
p {
  margin: 0px;
}
.patient-detail h3,
p {
  font-size: 16px;
}
h3 {
  color: #453f3f;
  letter-spacing: 1px;
  font-weight: 400;
}
.v-chip.v-size--default {
  border-radius: 16px;
  font-size: 14px;
  height: 100%;
}
.col {
  padding: 7px 12px !important;
}
.card--title {
  letter-spacing: 2px;
  font-size: 20px;
  font-weight: 400;
}

.header {
  background-color: rgba(249, 233, 63, 0.735);
  border-radius: 5px;
}
.header-result {
  background-color: #4f90ff;
  border-radius: 5px;
}
.header-result h3 {
  color: #fff !important;
}
.header-test {
  border-radius: 5px;
  background-color: #fec853;
}
</style>
